<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='success' icon='wms wms-qrcode' class='navbarbtn' v-if='showCreateQRCodePower'
        @click='showCreateQRCodeDialogMD'>
        生成条码
      </el-button>

      <el-button type='success' icon='wms wms-qrcode' class='navbarbtn' v-if='showCreateOneItemQRCodePower'
        @click='showCreateOneItemQRCodeDialogMD'>
        生成条码（单物料）
      </el-button>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintDeliveryBillPower'
        @click='printDeliveryBill'>
        打印送货单
      </el-button>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='60px'
      :reduceHeight='200' :seqFixed='true'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :expandRowKeys='mainTable.expandRowKeys'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='条码明细' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showQRCodeDialogMD(scope)'><i class='wms wms-qrcode'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成标签</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>到货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='pdbe in scope.data.row.detailDt1' :style='mainTableDetail1RowStyle(scope.data.row, pdbe)'
            :key='pdbe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{pdbe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{pdbe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{pdbe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{pdbe.Qty}}{{pdbe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{pdbe.CreateQRCodeQty}}{{pdbe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{pdbe.CommitQty}}{{pdbe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{pdbe.StockQty}}{{pdbe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{pdbe.ReturnQty}}{{pdbe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{pdbe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog title='生成标签' :visible.sync='showCreateQRCodeDialog' fullscreen>
      <el-table :data='qrcodeRows' border :height='getCreateQRCodeHeight()' ref='createQRCodeTable'
        :cell-style='{ padding: "0px" }' :header-cell-style='createQRCodeHeaderCellStyle' size='medium'
        style='margin-top: -35px;'>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='280'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='280'>
        </el-table-column>
        <el-table-column prop='Qty' label='本次送货单数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateQRCodeQty' label='已经生成标签数量' width='80'>
        </el-table-column>
        <el-table-column prop='ThisCreateQty' label='本次生成标签数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisCreateQty' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='ThisUnitPackageNumber' label='每包数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisUnitPackageNumber' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='ThisUnitBoxNumber' label='每箱最大包数' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisUnitBoxNumber' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='160'>
          <template #default='scope'>
            <el-date-picker style='width: 140px;' size='mini'
              v-model='scope.row.KFDate' value-format='yyyy-MM-dd'
              @input='createQRCodeTableKFDateChange(scope.row)'></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop='SupplyBatchNo' label='供应商批号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.SupplyBatchNo' style='width: 80px;'/>
          </template>
        </el-table-column>
        <!-- <el-table-column prop='ProducetItemID' label='专用产品号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ProducetItemID' style='width: 80px;'/>
          </template>
        </el-table-column> -->
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='SupplyName' label='供应商' width='200'>
        </el-table-column>
        <el-table-column prop='MTONo' label='计划跟踪号' width='200'>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button class='inputField-input' type='primary' @click='autoCompleteCreateQRCodeQty()'
          size='mini'>自动填充生成数量</el-button>
        <el-button class='inputField-input' type='primary' @click='clearCreateQRCodeQty()'
          size='mini'>清除生成数量</el-button>
        <el-button type='primary' @click='createQRCode()' size='mini'>生成并打印</el-button>
        <el-button @click='showCreateQRCodeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='生成标签（单物料）' :visible.sync='showCreateOneItemQRCodeDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 90px; text-align: left'>
          每箱最大包数
        </div>
        <el-input size='mini' class='inputField-input' v-model='UnitBoxNumber' style='width: 100px;'
          placeholder='请输入'></el-input>
        <div class='inputField-label' style='width: 120px; text-align: left'>
          本次标签合计数量
        </div>
        <el-input size='mini' class='inputField-input' v-model='sumQty' style='width: 100px;' disabled
          placeholder='请输入'></el-input>
      </div>
      <el-table :data='deliveryBillRows' border :height='getCreateOneItemQRCodeHeightTop()'
        :row-style='selectOneItemQRCodeRowStyle'
        :header-cell-style='createOneItemQRCodeHeaderCellStyle'
        @row-dblclick='selectOneItem' ref='selectOneItemQRCodeTable'
        :cell-style='{ padding: "0px" }' size='medium' style='margin-top: 40px;'>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='280'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='280'>
        </el-table-column>
        <el-table-column prop='Qty' label='本次送货单数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateQRCodeQty' label='已经生成标签数量' width='80'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='SupplyName' label='供应商' width='200'>
        </el-table-column>
        <el-table-column label='操作' width='50' fixed='right'>
          <template #default='scope'>
            <el-tooltip effect='dark' content='取消选择' placement='top-start' v-if='scope.row.selected'>
              <el-button type='danger' circle style='padding: 4px;'
                @click='cancelSelectOneItem(scope.row)'><i class='sys sys-cancel'></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data='itemQRCodeRows' border :height='getCreateOneItemQRCodeHeightBottom()' ref='createOneItemQRCodeTable'
        :cell-style='{ padding: "0px" }' :header-cell-style='createOneItemQRCodeHeaderCellStyle'
        style='margin-top: 10px;' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='350'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='280'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='物料规格' width='280'>
        </el-table-column>
        <el-table-column prop='Qty' label='本次送货单数量' width='80'>
        </el-table-column>
        <el-table-column prop='CreateQRCodeQty' label='已经生成标签数量' width='80'>
        </el-table-column>
        <el-table-column prop='ThisCreateQty' label='本次生成标签数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisCreateQty' style='width: 60px;' @blur='sumQtyComputer'/>
          </template>
        </el-table-column>
        <el-table-column prop='ThisUnitPackageNumber' label='每包数量' width='80'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ThisUnitPackageNumber' style='width: 60px;'/>
          </template>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='160'>
          <template #default='scope'>
            <el-date-picker style='width: 140px;' size='mini'
              v-model='scope.row.KFDate' value-format='yyyy-MM-dd' :disabled='scope.$index != 0'
              @input='createOneItemQRCodeTableKFDateChange(scope.row)'></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop='SupplyBatchNo' label='供应商批号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.SupplyBatchNo' style='width: 80px;'/>
          </template>
        </el-table-column>
        <!-- <el-table-column prop='ProducetItemID' label='专用产品号' width='100'>
          <template #default='scope'>
            <input class='tableInput' v-model='scope.row.ProducetItemID' :disabled='scope.$index != 0'
              @input='createOneItemQRCodeTableProducetItemIDChange(scope.row)' style='width: 80px;'/>
          </template>
        </el-table-column> -->
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='SupplyName' label='供应商' width='200'>
        </el-table-column>
        <el-table-column prop='MTONo' label='计划跟踪号' width='200'>
        </el-table-column>
        <el-table-column label='操作' width='50' fixed='right'>
          <template #default='scope'>
            <el-tooltip effect='dark' content='删除' placement='top-start'>
              <el-button type='danger' circle style='padding: 4px;'
                @click='deleteOneItemQRCodeRow(scope.row, scope.$index)'><i class='sys sys-delete'></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='addOneItemQRCodeRow()' size='mini'>添加行</el-button>
        <el-button type='primary' @click='createOneItemQRCode()' size='mini'>生成并打印</el-button>
        <el-button @click='showCreateOneItemQRCodeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='标签明细' :visible.sync='showQRCodeDialog' width='1000px'
      top='10px' lock-scroll>
      <el-table :data='showOuterQRCodes' v-show='showOuterQRCodesFlag' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60' fixed>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200' fixed>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='总数量' width='60'>
        </el-table-column>
        <el-table-column prop='PackageQty' label='总包数' width='60'>
        </el-table-column>
      </el-table>
      <el-table :data='showQRCodes' v-show='!showOuterQRCodesFlag' border height='300px' :row-style='showQRCodesRowStyle'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60' fixed>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200' fixed>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='ProducetItemID' label='专用产品号' width='160'>
        </el-table-column>
        <el-table-column prop='Status' label='状态' width='60'>
          <template #default='scope'>
            {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
          </template>
        </el-table-column>
        <el-table-column prop='PrintCount' label='已打印次数' width='100'>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button class='inputField-input' type='primary' @click='showDeletedQRCodes = true; showQRCodeDialogMD(showQRCodesScope)' v-if='!showDeletedQRCodes'
          size='mini'>显示已作废</el-button>
        <el-button class='inputField-input' type='success' @click='showDeletedQRCodes = false; showQRCodeDialogMD(showQRCodesScope)' v-if='showDeletedQRCodes'
          size='mini'>隐藏已作废</el-button>
        <el-button class='inputField-input' type='primary' @click='showOuterQRCodesFlag = true;' v-if='!showOuterQRCodesFlag'
          size='mini'>显示外箱标签</el-button>
        <el-button class='inputField-input' type='success' @click='showOuterQRCodesFlag = false;' v-if='showOuterQRCodesFlag'
          size='mini'>显示内箱标签</el-button>
        <el-button @click='showQRCodeDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'CreatePOQRCode',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PO_DeliveryBill',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,
        customFilterStr: ' AND 1=0 ',

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showCreateQRCodeDialog: false,
      qrcodeRows: [],

      showCreateOneItemQRCodeDialog: false,
      deliveryBillRows: [],
      itemQRCodeRows: [],
      UnitBoxNumber: 0,
      selectIndex: -1,
      sumQty: 0,

      showQRCodeDialog: false,
      showQRCodes: [],
      showOuterQRCodes: [],
      showQRCodesScope: {},
      qrcodeStatuss: [],
      showDeletedQRCodes: false,
      showOuterQRCodesFlag: false,

      showCreateQRCodePower: false,
      showCreateOneItemQRCodePower: false,
      showPrintDeliveryBillPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.qrcodeStatuss = code.getCode(codes, 'WMS_QRCode_Status')

    const rtnObjPromise = axiosHelper.handle('/WebAction/BaseData.User.GetUserSupply', {
    })
    const rtnObj = await rtnObjPromise
    if (rtnObj && rtnObj.error === '000000') {
      if (rtnObj.supplyRoleFlag === '0' && rtnObj.purchaseManagerRoleFlag === '0') {
        that.mainTable.customFilterStr = ''
      } else {
        let customFilterStr = " AND SupplyID IN (''"
        for (let i = 0; i < rtnObj.supplys.length; i++) {
          customFilterStr += ",'" + rtnObj.supplys[i].SupplyID + "'"
        }
        customFilterStr += ')'
        that.mainTable.customFilterStr = customFilterStr
      }
    }

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
      that.mainTable.detail1FilterStr = ''
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.MrpClosed === '1' || data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2' || data.row.Status === '1') {
        if (data.row.DeliveryStatus === '2') {
          return { 'background-color': '#cccccc' }
        } else if (data.row.DeliveryStatus === '1') {
          return { 'background-color': 'orange' }
        } else if (data.row.CreateQRCodeStatus === '2') {
          return { 'background-color': 'orange' }
        } else {
          return {}
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开行行样式设定方法
    mainTableDetail1RowStyle: function (row, pdbe) {
      return {}
    },

    // 获取条码弹出框表格高度
    getCreateQRCodeHeight: function () {
      return window.innerHeight - 120 + 'px'
    },

    // 获取单物料条码弹出框表格高度(上)
    getCreateOneItemQRCodeHeightTop: function () {
      return (window.innerHeight - 180) * 0.4 + 'px'
    },

    // 获取单物料条码弹出框表格高度(下)
    getCreateOneItemQRCodeHeightBottom: function () {
      return (window.innerHeight - 180) * 0.6 + 'px'
    },

    // 创建二维码弹出框表格头部样式
    createQRCodeHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      if (column.property && (column.property === 'ThisCreateQty' ||
        column.property === 'ThisUnitPackageNumber' ||
        column.property === 'ThisUnitBoxNumber' ||
        column.property === 'KFDate' || column.property === 'SupplyBatchNo' ||
        column.property === 'ProducetItemID')) {
        return { color: 'blue', padding: '5px', 'background-color': '#f5f7fa' }
      } else {
        return { padding: '5px', 'background-color': '#f5f7fa' }
      }
    },

    // 单物料创建二维码弹出框表格头部样式
    createOneItemQRCodeHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      if (column.property && (column.property === 'ThisCreateQty' ||
        column.property === 'ThisUnitPackageNumber' ||
        column.property === 'ThisUnitBoxNumber' ||
        column.property === 'KFDate' || column.property === 'SupplyBatchNo' ||
        column.property === 'ProducetItemID')) {
        return { color: 'blue', padding: '5px', 'background-color': '#f5f7fa' }
      } else {
        return { padding: '5px', 'background-color': '#f5f7fa' }
      }
    },

    // 单物料创建二维码弹出框选择物料表格行样式
    selectOneItemQRCodeRowStyle: function ({ row, rowIndex }) {
      if (row.selected) {
        return { 'background-color': 'lightblue' }
      } else {
        return {}
      }
    },

    // 创建条码弹出框显示
    showCreateQRCodeDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      if (that.mainTable.selections.length !== 1) {
        that.$message.error('请选择单条数据！')
        return
      }
      let AllCanCreateQRCodeQty = 0
      for (let i = 0; i < that.mainTable.selections[0].detailDt1.length; i++) {
        AllCanCreateQRCodeQty += that.mainTable.selections[0].detailDt1[i].CanCreateQRCodeQty
      }
      if (AllCanCreateQRCodeQty <= 0) {
        that.$message.error('请选择可生成标签数量大于零的数据！')
        return
      }
      that.qrcodeRows = that.mainTable.selections[0].detailDt1
      that.qrcodeRows.forEach(qrcodeRow => {
        qrcodeRow.ThisCreateQty = 0
        qrcodeRow.ThisUnitPackageNumber = qrcodeRow.UnitPackageNumber
        qrcodeRow.ThisUnitBoxNumber = '0'
        qrcodeRow.BatchNo = ''
        qrcodeRow.SupplyBatchNo = ''
        qrcodeRow.KFDate = ''
      })
      that.showCreateQRCodeDialog = true
    },

    // 生成标签表格生产/采购日期变更方法
    createQRCodeTableKFDateChange: function (row) {
      const that = this
      if (row.KFDate) {
        try {
          row.KFDate = dateTimeUtil.formartDateTime(new Date(row.KFDate), 'yyyy-MM-dd')
          row.BatchNo = row.KFDate.replace(/-/g, '')
          if (row.KFDate.length !== 10) {
            row.KFDate = ''
            that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
            row.BatchNo = ''
          }
          that.$refs.createQRCodeTable.doLayout()
        } catch {
          that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
          row.KFDate = ''
          row.BatchNo = ''
          that.$refs.createQRCodeTable.doLayout()
        }
      } else {
        that.$refs.createQRCodeTable.doLayout()
      }
    },

    // 自动填充生成数量
    autoCompleteCreateQRCodeQty: function () {
      const that = this
      that.qrcodeRows.forEach(qrcodeRow => {
        qrcodeRow.ThisCreateQty = qrcodeRow.Qty - qrcodeRow.CreateQRCodeQty
      })
      that.$refs.createQRCodeTable.doLayout()
    },

    // 清除生成数量
    clearCreateQRCodeQty: function () {
      const that = this
      that.qrcodeRows.forEach(qrcodeRow => {
        qrcodeRow.ThisCreateQty = 0
      })
      that.$refs.createQRCodeTable.doLayout()
    },

    // 生成并打印标签
    createQRCode: async function () {
      const that = this
      let allThisCreateQty = 0
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.qrcodeRows.length; i++) {
        if (that.qrcodeRows[i].ThisCreateQty && !numberReg.test(that.qrcodeRows[i].ThisCreateQty)) {
          that.$message.error('本次生成标签数量必须为不小于0的数字！')
          return
        }
        allThisCreateQty += parseFloat(that.qrcodeRows[i].ThisCreateQty)
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && (!that.qrcodeRows[i].ThisUnitPackageNumber || that.qrcodeRows[i].ThisUnitPackageNumber === '0')) {
          that.$message.error('请输入每包数量！')
          return
        }
        if (that.qrcodeRows[i].ThisUnitPackageNumber &&
          !numberReg.test(that.qrcodeRows[i].ThisUnitPackageNumber)) {
          that.$message.error('每包数量必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && ((!that.qrcodeRows[i].ThisUnitPackageNumber || that.qrcodeRows[i].ThisUnitPackageNumber === '0') ||
          !numberReg.test(that.qrcodeRows[i].ThisUnitBoxNumber))) {
          that.$message.error('每箱最大包数必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && !that.qrcodeRows[i].KFDate) {
          that.$message.error('请输入生产/采购日期！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && !that.qrcodeRows[i].BatchNo) {
          that.$message.error('请输入批号！')
          return
        }
        if (parseFloat(that.qrcodeRows[i].ThisCreateQty) > 0 && !that.qrcodeRows[i].SupplyBatchNo) {
          that.$message.error('请输入供应商批号！')
          return
        }
      }
      if (allThisCreateQty <= 0) {
        that.$message.error('至少有一个大于0的本次生成标签数量！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CreatePOQRCode', {
        rows: that.qrcodeRows
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，生成采购标签成功！')
        that.showCreateQRCodeDialog = false
        const qrcodesObj = JSON.parse(rtnObj.msg.replace(/'/g, '"'))
        const qrcodesAry = []
        for (let i = 0; i < qrcodesObj.qrcodes.length; i++) {
          qrcodesAry.push(qrcodesObj.qrcodes[i].QRCode)
        }
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=QRCode.rpt', 'QRCode')
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=OuterQRCode.rpt', 'OuterQRCode')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 创建条码（单物料）弹出框显示
    showCreateOneItemQRCodeDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      if (that.mainTable.selections.length !== 1) {
        that.$message.error('请选择单条数据！')
        return
      }
      let AllCanCreateQRCodeQty = 0
      for (let i = 0; i < that.mainTable.selections[0].detailDt1.length; i++) {
        AllCanCreateQRCodeQty += that.mainTable.selections[0].detailDt1[i].CanCreateQRCodeQty
      }
      if (AllCanCreateQRCodeQty <= 0) {
        that.$message.error('请选择可生成标签数量大于零的数据！')
        return
      }
      that.deliveryBillRows = that.mainTable.selections[0].detailDt1
      that.deliveryBillRows.forEach(bill => {
        bill.selected = false
      })
      that.itemQRCodeRows = []
      that.showCreateOneItemQRCodeDialog = true
      that.$nextTick(() => {
        if (that.deliveryBillRows.length === 1) {
          that.selectOneItem(that.deliveryBillRows[0])
        }
      })
    },

    // 创建条码（单物料）选中方法
    selectOneItem: function (row) {
      const that = this
      for (let i = 0; i < that.deliveryBillRows.length; i++) {
        if (that.deliveryBillRows[i].selected === true) {
          return
        }
      }
      for (let i = 0; i < that.deliveryBillRows.length; i++) {
        if (that.deliveryBillRows[i].EntryID === row.EntryID) {
          that.selectIndex = i
          break
        }
      }
      row.selected = true
      that.$refs.selectOneItemQRCodeTable.doLayout()
    },

    // 创建条码（单物料）取消选中方法
    cancelSelectOneItem: function (row) {
      const that = this
      if (that.itemQRCodeRows.length > 0) {
        that.$message.error('请先清空下方生成条码数据！')
        return
      }
      that.selectIndex = -1
      row.selected = false
      that.$refs.selectOneItemQRCodeTable.doLayout()
    },

    // 生成标签表格生产/采购日期变更方法
    createOneItemQRCodeTableKFDateChange: function (row) {
      const that = this
      if (row.KFDate) {
        try {
          row.KFDate = dateTimeUtil.formartDateTime(new Date(row.KFDate), 'yyyy-MM-dd')
          row.BatchNo = row.KFDate.replace(/-/g, '')
          if (row.KFDate.length !== 10) {
            row.KFDate = ''
            that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
            row.BatchNo = ''
          }
          for (let i = 0; i < that.itemQRCodeRows.length; i++) {
            that.itemQRCodeRows[i].KFDate = row.KFDate
            that.itemQRCodeRows[i].BatchNo = row.BatchNo
          }
          that.$refs.createOneItemQRCodeTable.doLayout()
        } catch {
          that.$message.error('请输入正确格式的日期！（例如2020-01-01）')
          row.KFDate = ''
          row.BatchNo = ''
          for (let i = 0; i < that.itemQRCodeRows.length; i++) {
            that.itemQRCodeRows[i].KFDate = row.KFDate
            that.itemQRCodeRows[i].BatchNo = row.BatchNo
          }
          that.$refs.createOneItemQRCodeTable.doLayout()
        }
      } else {
        for (let i = 0; i < that.itemQRCodeRows.length; i++) {
          that.itemQRCodeRows[i].KFDate = row.KFDate
          that.itemQRCodeRows[i].BatchNo = row.BatchNo
        }
        that.$refs.createOneItemQRCodeTable.doLayout()
      }
    },

    // 生成标签表格专用产品号变更方法
    createOneItemQRCodeTableProducetItemIDChange: function (row) {
      const that = this
      for (let i = 0; i < that.itemQRCodeRows.length; i++) {
        that.itemQRCodeRows[i].ProducetItemID = row.ProducetItemID
      }
    },

    // 单物料生成标签添加行方法
    addOneItemQRCodeRow: function () {
      const that = this
      if (that.selectIndex < 0) {
        that.$message.error('请先选择物料！')
        return
      }
      that.itemQRCodeRows.push(Object.assign({}, that.deliveryBillRows[that.selectIndex], {
        ThisCreateQty: 0,
        ThisUnitPackageNumber: that.deliveryBillRows[that.selectIndex].UnitPackageNumber,
        BatchNo: that.itemQRCodeRows.length > 0 ? that.itemQRCodeRows[0].BatchNo : '',
        SupplyBatchNo: '',
        ProducetItemID: that.itemQRCodeRows.length > 0 ? that.itemQRCodeRows[0].ProducetItemID : '',
        KFDate: that.itemQRCodeRows.length > 0 ? that.itemQRCodeRows[0].KFDate : ''
      }))
    },

    // 单物料生成标签删除行方法
    deleteOneItemQRCodeRow: function (row, index) {
      const that = this
      that.itemQRCodeRows.splice(index, 1)
    },

    // 合计数量计算
    sumQtyComputer: function () {
      const that = this
      that.sumQty = 0
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      for (let i = 0; i < that.itemQRCodeRows.length; i++) {
        if (that.itemQRCodeRows[i].ThisCreateQty && !numberReg.test(that.itemQRCodeRows[i].ThisCreateQty)) {
          continue
        }
        that.sumQty += parseFloat(that.itemQRCodeRows[i].ThisCreateQty)
      }
    },

    // 生成并打印标签
    createOneItemQRCode: async function () {
      const that = this
      let allThisCreateQty = 0
      const numberReg = /^[0-9]{1,}([.][0-9]*)?$/
      if (that.itemQRCodeRows.length <= 0) {
        that.$message.error('请添加行！')
        return
      }
      for (let i = 0; i < that.itemQRCodeRows.length; i++) {
        if (that.itemQRCodeRows[i].ThisCreateQty && !numberReg.test(that.itemQRCodeRows[i].ThisCreateQty)) {
          that.$message.error('本次生成标签数量必须为不小于0的数字！')
          return
        }
        allThisCreateQty += parseFloat(that.itemQRCodeRows[i].ThisCreateQty)
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].ThisUnitPackageNumber) {
          that.$message.error('请输入每包数量！')
          return
        }
        if (that.itemQRCodeRows[i].ThisUnitPackageNumber &&
          !numberReg.test(that.itemQRCodeRows[i].ThisUnitPackageNumber)) {
          that.$message.error('每包数量必须为不小于0的数字！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].KFDate) {
          that.$message.error('请输入生产/采购日期！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].BatchNo) {
          that.$message.error('请输入批号！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0 && !that.itemQRCodeRows[i].SupplyBatchNo) {
          that.$message.error('请输入供应商批号！')
          return
        }
        if (parseFloat(that.itemQRCodeRows[i].ThisCreateQty) > 0) {
        } else {
          that.$message.error('本次生成标签数量必须大于0！')
          return
        }
      }
      if (!that.UnitBoxNumber ||
        !numberReg.test(that.UnitBoxNumber)) {
        that.$message.error('每箱最大包数必须为不小于0的数字！')
        return
      }
      if ((Math.round(allThisCreateQty * 100000000) / 100000000) > that.deliveryBillRows[that.selectIndex].CanCreateQRCodeQty) {
        that.$message.error('合计【本次生成标签数量】不能超过该物料的【本次送货单数量】-【已生成标签数量】！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CreateOneItemPOQRCode', {
        deliveryBillEntry: that.deliveryBillRows[that.selectIndex],
        rows: that.itemQRCodeRows,
        unitBoxNumber: that.UnitBoxNumber
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('恭喜你，生成采购标签成功！')
        that.showCreateOneItemQRCodeDialog = false
        const qrcodesObj = JSON.parse(rtnObj.msg.replace(/'/g, '"'))
        const qrcodesAry = []
        for (let i = 0; i < qrcodesObj.qrcodes.length; i++) {
          qrcodesAry.push(qrcodesObj.qrcodes[i].QRCode)
        }
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=0&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=QRCode.rpt', 'QRCode')
        window.open('/WebPrint/Print.Print.GetQRCodePrintDataSet?printouter=2&qrcodes=' + JSON.stringify(qrcodesAry) + '&reportName=OuterQRCode.rpt', 'OuterQRCode')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 显示条码明细弹出框
    showQRCodeDialogMD: function (scope) {
      const that = this
      that.showQRCodes = []
      that.showOuterQRCodes = []
      that.showQRCodesScope = scope
      scope.data.row.detailDt2.forEach(showQRCode => {
        if (showQRCode.Status !== '9' || that.showDeletedQRCodes) {
          that.showQRCodes.push(showQRCode)
        }
        if (showQRCode.OuterQRCode && showQRCode.Status !== '9') {
          let OuterQRCodeIndex = -1
          for (let i = 0; i < that.showOuterQRCodes.length; i++) {
            if (that.showOuterQRCodes[i].OuterQRCode === showQRCode.OuterQRCode) {
              OuterQRCodeIndex = i
              break
            }
          }
          if (OuterQRCodeIndex < 0) {
            that.showOuterQRCodes.push(Object.assign({}, showQRCode, {
              QRCode: null,
              PackageQty: 1
            }))
          } else {
            that.showOuterQRCodes[OuterQRCodeIndex].Qty += showQRCode.Qty
            that.showOuterQRCodes[OuterQRCodeIndex].PackageQty++
          }
        }
      })
      that.showQRCodeDialog = true
    },

    // 显示条码明细表格特征字符串转换方法
    showQRCodesTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'Status') {
        return table.specialStringDisplayTransform(val, that.qrcodeStatuss)
      }
    },

    // 显示条码明细表格行样式设定方法
    showQRCodesRowStyle: function (data, rowIndex) {
      if (data.row.Status === '9') {
        return { 'background-color': '#cccccc' }
      } else {
        return {}
      }
    },

    // 打印送货单
    printDeliveryBill: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const deliveryBillNoAry = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        deliveryBillNoAry.push(that.mainTable.selections[i].DeliveryBillNo)
      }
      window.open('/WebPrint/Print.Print.GetDeliveryBillPrintDataSet?deliveryBillNos=' + JSON.stringify(deliveryBillNoAry) + '&reportName=PODevOrder.rpt')
      that.refreshMainTableContent()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
